export default __webpack_public_path__ + "static/sesame1-1cc3c7b97fc16275c155bb559d544045.webp";